module.exports = __webpack_public_path__ + "static/media/res3.6ed70c30.PNG";